import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import permissions from "app/permissions";
import { NON_WORKING_OCCURRENCES, StudentServicePath } from "utils/constants";
import ListRescheduleOccurrences from "./List";

export const resources = {
  isMenu: true,
  icon: <EventRepeatIcon />,
  name: StudentServicePath + NON_WORKING_OCCURRENCES,
  title: "Пренасрочване на занятия",
  permission: permissions.canPreviewWeeklySchedule,
  list: <ListRescheduleOccurrences />,
};
